
/**
 * @component Picture
 *
 * @public
 */

export default {
  name: 'Picture',
  props: {
    ratio: {
      type: String,
      default: '16x9',
    },
  },
  computed: {
    /**
     * Create class name based on ratio,
     *
     * @return {String}
     * @private
     */

    classRatio() {
      return `ratio${this.ratio}`;
    },
  },
};
